import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getIdToken, isCoach } from "../lib/auth";

/**
 * Catch-all for any URL that matches no route.
 *
 * Without this, a typo or a stale bookmark rendered the brand bar and nothing else -- a blank page with
 * no error and no way back, which reads as the app being broken rather than the address being wrong.
 *
 * The way home depends on who you are, and a signed-out visitor's way home is the login page, so the
 * destination is resolved rather than hardcoded.
 */
export function NotFound() {
  const [home, setHome] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    getIdToken()
      .then(async (token) => {
        if (cancelled) return;
        setHome(token && (await isCoach()) ? "/dashboard" : token ? "/family" : "/");
      })
      // Never leave the button missing: if the session check fails for any reason, the login page is
      // still a valid place to send someone.
      .catch(() => {
        if (!cancelled) setHome("/");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="centered-page">
      <div className="card">
        <h1>Page not found</h1>
        <p className="plan-summary">That link doesn&rsquo;t go anywhere. It may be out of date.</p>
        <button type="button" onClick={() => navigate(home ?? "/")} disabled={home === null}>
          Take me back
        </button>
      </div>
    </div>
  );
}
